export default {
  name: 'GraphExample',
  title: 'Graph Example',
  owner: 'User: Nachi Mistry',
  solution: '',
  tags: ['data', 'visualization', 'graph'],
  createdAt: 'May 30, 2023, 10:14 AM',
  updatedAt: 'May 31, 2023, 11:14 AM',
  spec: {
    data: {
      demo: {
        data: {
          nodes: [
            {
              id: 'Type:APPLICATION_COMPONENT, id:44',
              name: 'Web-Tier-Services',
            },
            {
              id: 'Type:APPLICATION_COMPONENT, id:34',
              name: 'ECommerce-Services',
            },
            {
              id: 'Type:APPLICATION_COMPONENT, id:37',
              name: 'Order-Processing-Services',
            },
            {
              id: 'Type:APPLICATION_COMPONENT, id:38',
              name: 'Inventory-Services',
            },
            {
              id: 'Type:BACKEND, id:4',
              name: 'XE-Oracle-ORACLE-DB-Oracle Database 11g Express Edition Release 11.2.0.2.0 - 64bit Production',
            },
            {
              id: 'Type:BACKEND, id:2',
              name: 'APPDY-MySQL-DB-5.5.5-10.1.29-MariaDB',
            },
            {
              id: 'Type:BACKEND, id:11',
              name: 'Active MQ-CustomerQueue',
            },
            {
              id: 'Type:BACKEND, id:10',
              name: 'Active MQ-fulfillmentQueue',
            },
            {
              id: 'Type:BACKEND, id:9',
              name: 'Active MQ-OrderQueue',
            },
            {
              id: 'Type:BACKEND, id:12',
              name: 'api.shipping.com:3000',
            },
            {
              id: 'Type:APPLICATION, id:23',
              name: 'ECommerce-Sales-Demo-Fulfillment',
            },
            {
              id: 'Type:BACKEND, id:7',
              name: 'INVENTORY-MySQL DB-DB-5.5.5-10.1.29-MariaDB',
            },
          ],
          edges: [
            {
              from: 'Type:BACKEND, id:10',
              to: 'Type:APPLICATION_COMPONENT, id:37',
            },
            {
              from: 'Type:APPLICATION_COMPONENT, id:34',
              to: 'Type:BACKEND, id:4',
            },
            {
              from: 'Type:APPLICATION_COMPONENT, id:34',
              to: 'Type:BACKEND, id:10',
            },
            {
              from: 'Type:APPLICATION_COMPONENT, id:34',
              to: 'Type:BACKEND, id:11',
            },
            {
              from: 'Type:APPLICATION_COMPONENT, id:34',
              to: 'Type:BACKEND, id:2',
            },
            {
              from: 'Type:APPLICATION_COMPONENT, id:34',
              to: 'Type:BACKEND, id:12',
            },
            {
              from: 'Type:APPLICATION_COMPONENT, id:44',
              to: 'Type:APPLICATION_COMPONENT, id:34',
            },
            {
              from: 'Type:BACKEND, id:9',
              to: 'Type:APPLICATION_COMPONENT, id:37',
            },
            {
              from: 'Type:APPLICATION_COMPONENT, id:34',
              to: 'Type:APPLICATION_COMPONENT, id:38',
            },
            {
              from: 'Type:APPLICATION_COMPONENT, id:37',
              to: 'Type:APPLICATION, id:23',
            },
            {
              from: 'Type:APPLICATION_COMPONENT, id:38',
              to: 'Type:BACKEND, id:7',
            },
            {
              from: 'Type:APPLICATION_COMPONENT, id:34',
              to: 'Type:BACKEND, id:9',
            },
            {
              from: 'Type:APPLICATION_COMPONENT, id:38',
              to: 'Type:BACKEND, id:4',
            },
          ],
        },
      },
    },
    view: [
      {
        instanceOf: 'div',
        className: '${ "h-[400px] w-[400px]" }',
        children: [['dashify:Graph', '${ data.demo.data }']],
      },
    ],
  },
};
